import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import { installAuthHeaders } from "@/lib/authHeaders";
import { installDuplicateGuard } from "@/components/DuplicateGuard";
import { installDateGuard } from "@/lib/dateGuard";

installAuthHeaders();
installDuplicateGuard();
installDateGuard();

// Tell the backend which environment the user is actually on. Cloudflare/the
// k8s ingress rewrites Host/Origin to internal cluster hosts, so this custom
// header (which is never rewritten) is the most reliable signal used by the
// backend to gate automated emails to production only.
if (typeof window !== "undefined") {
  axios.defaults.headers.common["X-Client-Origin"] = window.location.origin;
}

// Public landing loads only its own small chunk; everything else loads the full app.
const LANDING_PATHS = ["/new-home"];
const Root = React.lazy(() => (LANDING_PATHS.includes(window.location.pathname) ? import("@/pages/NewLandingPage") : import("@/App")));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <React.Suspense fallback={null}>
      <Root />
    </React.Suspense>
  </React.StrictMode>,
);
